import { render, staticRenderFns } from "./ConfigAsset.vue?vue&type=template&id=67fd2944&"
import script from "./ConfigAsset.vue?vue&type=script&lang=js&"
export * from "./ConfigAsset.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAsset.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports